// import { useEffect, useState } from 'react';
// import SweetAlert from '../../Shared/Notification';
// import { useNavigate, useParams } from 'react-router-dom';
// import additional_attributes_dict from '../CommonAttr';
// import APIService from '../../../Services/APIService';
// import TableHeader from '../../Shared/TableHeader/index';
// import {
//   Form,
//   FormGroup,
//   FormControl,
//   FormLabel,
//   Row,
//   Col,
//   Button,
//   CloseButton,
//   Modal
// } from 'react-bootstrap';
// import SelectDropdown from '../../Shared/SelectDropdown';
// import { BackButton } from '../../Shared/BackButton';

// export default function CreateType() {
//   const navigation = useNavigate();
//   const params = useParams();
//   const supplierTypeId = params.supplierTypeId;
//   const [baseSupplierTypeList, setBaseSupplierTypeList] = useState([]);
//   const [inventoryDataList, setInventoryDataList] = useState([]);
//   const additionalAttributesList = [
//     { label: 'Bank Details', value: 'bank_details' },
//     { label: 'Contact Details', value: 'contact_details' },
//     { label: 'Location Details', value: 'location_details' },
//     { label: 'Society Details', value: 'society_details' },
//   ];
//   const [state, setState] = useState({
//     isEditMode: !!supplierTypeId,
//     supplierTypeId,
//     name: '',
//     supplier_attributes: [{ name: '', type: '', is_required: false }],
//     selectedBaseSupplierType: {},
//     showOptionModal: false,
//     inventory_list: [],
//     additional_attributes: {},
//   });

//   const getBaseSupplierTypeList = async (data) => {
//     let res = await APIService.get(
//       `/v0/ui/dynamic-suppliers/base-supplier-type/?search=${data?.search}`
//     );
//     if (res.status == 200) {
//       let data = Object.values(res?.data?.list);
//       setBaseSupplierTypeList(data);
//     }
//   };

//   const getInventoryList = async () => {
//     let res = await APIService.get(`/v0/ui/dynamic-inventory/inventory/`);
//     if (res.status == 200) {
//       setInventoryDataList(Object.values(res?.data?.list));
//       // setState({ ...state, inventoryData: Object.values(res.data) });
//     }
//   };

//   const getSupplierType = async (supplierTypeId) => {
//     let res = await APIService.get(`/v0/ui/dynamic-suppliers/supplier-type/${supplierTypeId}/`);
//     if (res.status === 200) {
//       setState({ ...state, ...res?.data });
//     }
//   };

//   function isObjectBlank(obj) {
//     try {
//       return Object?.keys(obj)?.length === 0;
//     } catch {
//       return false;
//     }
//   }

//   const updateSupplierType = async (data, supplierTypeId) => {
//     let res = await APIService.put(
//       `/v0/ui/dynamic-suppliers/supplier-type/${supplierTypeId}/`,
//       data
//     );
//     if (res.status == 200) {
//       SweetAlert('Supplier Type updated successfully', 'success');
//       navigation(`/r/supplier/type/list`);
//     }
//   };

//   const getValueOfAttr = (e) => {
//     let val = additionalAttributesList?.find((item) => item?.value === e);
//     return val?.label || '';
//   };
//   const postSupplierType = async (data) => {
//     let res = await APIService.post(`/v0/ui/dynamic-suppliers/supplier-type/`, data);
//     if (res.status == 200) {
//       SweetAlert('Supplier Type created successfully', 'success');
//       navigation(`/r/supplier/type/list`);
//     }
//   };

//   const handleInputChange = (event) => {
//     setState({ ...state, [event.target.name]: event.target.value });
//   };

//   const onSubmitSupplierType = async (e) => {
//     e.preventDefault();
//     const { isEditMode, supplierTypeId } = state;
//     let data = {
//       name: state.name,
//       base_supplier_type_id: state.selectedBaseSupplierType?.id,
//       supplier_attributes: state.supplier_attributes,
//       // inventoryData: state.inventoryData,
//       inventory_list: state.inventory_list,
//       additional_attributes: state.additional_attributes,
//     };
//     if (isEditMode) updateSupplierType(data, supplierTypeId);
//     else postSupplierType(data);
//   };

//   const onSelectBaseSupplierType = (selectedBaseSupplierType) => {
//     if (selectedBaseSupplierType)
//       setState({
//         ...state,
//         selectedBaseSupplierType: selectedBaseSupplierType,
//         supplier_attributes: selectedBaseSupplierType?.supplier_attributes,
//       });
//   };

//   const onAdditionalAttributeChange = (selectedAdditionalAttribute) => {
//     setState({ ...state, selectedAdditionalAttribute });
//   };

//   const onAddAdditionalAttributes = () => {
//     const { additional_attributes, selectedAdditionalAttribute } = state;
//     additional_attributes[selectedAdditionalAttribute.value] =
//       additional_attributes_dict[selectedAdditionalAttribute.value];

//     setState({
//       ...state,
//       additional_attributes: additional_attributes,
//       selectedAdditionalAttribute: null,
//     });
//   };

//   const onInventoryChange = (selectedInventory) => {
//     setState({
//       ...state,
//       selectedInventory: selectedInventory,
//     });
//   };

//   const onAddInventory = () => {
//     const { inventory_list, selectedInventory } = state;
//     inventory_list.push(selectedInventory);
//     setState({
//       ...state,
//       inventory_list,
//       selectedInventory: null,
//     });
//   };

//   const onChangeAdditionalAttribute = (attribute, item, attributeIndex) => {
//     const newAttribute = { ...state?.additional_attributes };
//     newAttribute[attribute][attributeIndex].is_required =
//       !newAttribute[attribute][attributeIndex].is_required;
//     setState({
//       ...state,
//       additional_attributes: newAttribute,
//     });
//   };

//   const onRemoveAdditionalAttribute = (attribute) => {
//     const { additional_attributes } = state;
//     delete additional_attributes[attribute];
//     setState({ ...state, additional_attributes: additional_attributes });
//   };

//   //show inventory function
//   const onChangeInventoryAttribute = (parentIndex, attributeIndex, event) => {
//     let inventoryList = state?.inventory_list;
//     inventoryList[parentIndex]['inventory_attributes'][attributeIndex]['value'] =
//       !!event.target.checked;
//     setState({ ...state, inventory_list: inventoryList });
//   };

//   const onRemoveInventory = (index) => {
//     const newInventoryList = state.inventory_list;
//     newInventoryList.splice(index, 1);
//     setState({ ...state, inventory_list: newInventoryList });
//   };

//   const onSearchBaseSupplierType = (e) => {
//     getBaseSupplierTypeList({ search: e });
//   };
//   const backButton = () => {
//     return <BackButton onClick={() => navigation(-1)} />;
//   };

//   useEffect(() => {
//     const { isEditMode, supplierTypeId } = state;
//     getBaseSupplierTypeList({ search: '' });
//     getInventoryList();

//     if (isEditMode) {
//       getSupplierType(supplierTypeId);
//     }
//   }, []);

//   useEffect(() => {
//     if (state?.isEditMode && baseSupplierTypeList.length > 0) {
//       let obj = baseSupplierTypeList?.find((item) => item?.id === state?.base_supplier_type_id);
//       setState({ ...state, selectedBaseSupplierType: obj, base_supplier_type_id: obj?.id });
//     }
//   }, [baseSupplierTypeList]);

//   return (
//     <>
//       <div>
//         <TableHeader
//           headerValue={`Supplier Type - ${state.isEditMode ? 'Edit' : 'Create'}`}
//           isBackButton={backButton}
//         />
//         <Form onSubmit={onSubmitSupplierType}>
//           <Row>
//             <Col>
//               <FormGroup className="my-2">
//                 <FormLabel className="capitalize">
//                   Enter Name For Supplier Type <span className="required-field"> *</span>
//                 </FormLabel>
//                 <Form.Control
//                   type="text"
//                   placeholder={'Enter Name For Supplier Type'}
//                   name="name"
//                   value={state?.name || ''}
//                   onChange={(e) => handleInputChange(e)}
//                 />
//               </FormGroup>
//             </Col>
//             <Col>
//               <FormGroup className="my-2">
//                 <FormLabel className="capitalize">
//                   Select Base Supplier Type <span className="required-field"> *</span>
//                 </FormLabel>
//                 <SelectDropdown
//                   optionsData={baseSupplierTypeList}
//                   OptionLabel="name"
//                   OptionValue="id"
//                   selectedValue={
//                     isObjectBlank(state.selectedBaseSupplierType)
//                       ? null
//                       : state.selectedBaseSupplierType
//                   }
//                   placeholder="Supplier Type"
//                   label="Supplier Type"
//                   id="supplierType"
//                   handleSelect={onSelectBaseSupplierType}
//                   handleSearch={onSearchBaseSupplierType}
//                   // handleClear={() => {
//                   //   getBaseSupplierTypeList({ search: '' });
//                   // }}
//                   isClearable={true}
//                 />
//               </FormGroup>
//             </Col>
//           </Row>

//           <FormGroup className="my-2">
//             <FormLabel className="capitalize">Additional Attributes</FormLabel>
//             <div>
//               {Object.entries(state?.additional_attributes)?.map(([header, fields]) => (
//                 <div className="Additional Attributes" key={header}>
//                   <span>
//                     {getValueOfAttr(header)}
//                     <CloseButton
//                       onClick={(e) => onRemoveAdditionalAttribute(header)}
//                       style={{ paddingLeft: '10px' }}
//                     />
//                   </span>

//                   <div className="attributes-fields pt-2 pb-4">
//                     {fields?.map((field, index) => (
//                       <div key={field.name} className={`mb-2`}>
//                         <Form.Check
//                           type="checkbox"
//                           id={`${field?.name}`}
//                           name="option"
//                           label={field?.name}
//                           checked={field?.value || field?.is_required}
//                           onChange={() => onChangeAdditionalAttribute(header, field, index)}
//                         />
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//             <Row>
//               <Col className="">
//                 {' '}
//                 <SelectDropdown
//                   optionsData={additionalAttributesList}
//                   selectedValue={state?.selectedAdditionalAttribute}
//                   placeholder="Select Attributes"
//                   label="Select Type"
//                   id="SelectAttributes"
//                   handleSelect={onAdditionalAttributeChange}
//                   isClearable={true}
//                 />
//               </Col>
//               <Col>
//                 {' '}
//                 <Button
//                   type="button"
//                   onClick={onAddAdditionalAttributes}
//                   disabled={!state.selectedAdditionalAttribute}
//                 >
//                   Add Additional Attribute
//                 </Button>
//               </Col>
//             </Row>
//           </FormGroup>
//           <FormGroup className="my-2">
//             <FormLabel className="capitalize">Inventory</FormLabel>
//             <div className="inventory">
//               {state?.inventory_list?.length > 0 &&
//                 state?.inventory_list?.map((header, index) => {
//                   let mainIndex = index;
//                   return (
//                     <div key={`${header._id}${index}`}>
//                       <span>
//                         {header?.name}{' '}
//                         <CloseButton
//                           onClick={(e) => onRemoveInventory(mainIndex)}
//                           style={{ paddingLeft: '10px' }}
//                         />
//                       </span>
//                       <div className="attributes-fields pt-2 pb-4">
//                         {header?.inventory_attributes?.map((field, index) => (
//                           <div key={field.name} className={`mb-2`}>
//                             <Form.Check
//                               type="checkbox"
//                               id={`${mainIndex}${field?.name}${index}`}
//                               name="option"
//                               label={field?.name}
//                               checked={field?.value || field?.is_required}
//                               onChange={(e) => onChangeInventoryAttribute(mainIndex, index, e)}
//                               disabled={field.is_required}
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     </div>
//                   );
//                 })}
//             </div>
//             <Row>
//               <Col>
//                 {' '}
//                 <SelectDropdown
//                   optionsData={inventoryDataList}
//                   OptionLabel="name"
//                   OptionValue="_id"
//                   placeholder="Select Inventory"
//                   label="Select Inventory"
//                   id="SelectInventory"
//                   selectedValue={state.selectedInventory}
//                   handleSelect={onInventoryChange}
//                 />
//               </Col>
//               <Col>
//                 <Button type="button" onClick={onAddInventory} disabled={!state.selectedInventory}>
//                   Add Inventory
//                 </Button>
//               </Col>
//             </Row>
//           </FormGroup>
//           <Button
//             type="submit"
//             disabled={
//               state?.name?.trim().length <= 0 || isObjectBlank(state?.selectedBaseSupplierType)
//             }
//           >
//             Submit
//           </Button>
//         </Form>
//       </div>
//     </>
//   );
// }

import { useEffect, useState } from 'react';
import SweetAlert from '../../Shared/Notification';
import { useNavigate, useParams } from 'react-router-dom';
import additional_attributes_dict from '../CommonAttr';
import APIService from '../../../Services/APIService';
import CloseIcon from '@mui/icons-material/Close';
import { BackButton } from '../../Shared/BackButton';
import {
  Box,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  TextField,
  Typography,
} from '@mui/material';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';

export default function CreateType() {
  const navigation = useNavigate();
  const params = useParams();
  const supplierTypeId = params.supplierTypeId;
  const [baseSupplierTypeList, setBaseSupplierTypeList] = useState([]);
  const [inventoryDataList, setInventoryDataList] = useState([]);
  const additionalAttributesList = [
    { label: 'Bank Details', value: 'bank_details' },
    { label: 'Contact Details', value: 'contact_details' },
    { label: 'Location Details', value: 'location_details' },
    { label: 'Society Details', value: 'society_details' },
  ];
  const [state, setState] = useState({
    isEditMode: !!supplierTypeId,
    supplierTypeId,
    name: '',
    supplier_attributes: [{ name: '', type: '', is_required: false }],
    selectedBaseSupplierType: {},
    showOptionModal: false,
    inventory_list: [],
    additional_attributes: {},
  });

  const getBaseSupplierTypeList = async (data) => {
    let res = await APIService.get(
      `/v0/ui/dynamic-suppliers/base-supplier-type/?search=${data?.search}`
    );
    if (res.status == 200) {
      let data = Object.values(res?.data?.list);
      setBaseSupplierTypeList(data);
    }
  };

  const getInventoryList = async () => {
    let res = await APIService.get(`/v0/ui/dynamic-inventory/inventory/`);
    if (res.status == 200) {
      setInventoryDataList(Object.values(res?.data?.list));
      // setState({ ...state, inventoryData: Object.values(res.data) });
    }
  };

  const getSupplierType = async (supplierTypeId) => {
    let res = await APIService.get(`/v0/ui/dynamic-suppliers/supplier-type/${supplierTypeId}/`);
    if (res.status === 200) {
      setState({ ...state, ...res?.data });
    }
  };

  function isObjectBlank(obj) {
    try {
      return Object?.keys(obj)?.length === 0;
    } catch {
      return false;
    }
  }

  const updateSupplierType = async (data, supplierTypeId) => {
    let res = await APIService.put(
      `/v0/ui/dynamic-suppliers/supplier-type/${supplierTypeId}/`,
      data
    );
    if (res.status == 200) {
      SweetAlert('Supplier Type updated successfully', 'success');
      navigation(`/r/supplier/type/list`);
    }
  };

  const getValueOfAttr = (e) => {
    let val = additionalAttributesList?.find((item) => item?.value === e);
    return val?.label || '';
  };
  const postSupplierType = async (data) => {
    let res = await APIService.post(`/v0/ui/dynamic-suppliers/supplier-type/`, data);
    if (res.status == 200) {
      SweetAlert('Supplier Type created successfully', 'success');
      navigation(`/r/supplier/type/list`);
    }
  };

  const handleInputChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const onSubmitSupplierType = async (e) => {
    e.preventDefault();
    const { isEditMode, supplierTypeId } = state;
    let data = {
      name: state.name,
      base_supplier_type_id: state.selectedBaseSupplierType?.id,
      supplier_attributes: state.supplier_attributes,
      // inventoryData: state.inventoryData,
      inventory_list: state.inventory_list,
      additional_attributes: state.additional_attributes,
    };
    if (isEditMode) updateSupplierType(data, supplierTypeId);
    else postSupplierType(data);
  };

  const onSelectBaseSupplierType = (selectedBaseSupplierType) => {
    if (selectedBaseSupplierType) {
      setState({
        ...state,
        selectedBaseSupplierType,
        supplier_attributes: selectedBaseSupplierType?.supplier_attributes,
      });
    } else {
      // Handle clearing the selection
      setState({
        ...state,
        selectedBaseSupplierType: null,
        supplier_attributes: [],
      });
    }
  };

  const onAdditionalAttributeChange = (selectedAdditionalAttribute) => {
    setState({ ...state, selectedAdditionalAttribute });
  };

  const onAddAdditionalAttributes = () => {
    const { additional_attributes, selectedAdditionalAttribute } = state;
    additional_attributes[selectedAdditionalAttribute.value] =
      additional_attributes_dict[selectedAdditionalAttribute.value];

    setState({
      ...state,
      additional_attributes: additional_attributes,
      selectedAdditionalAttribute: null,
    });
  };

  const onInventoryChange = (selectedInventory) => {
    setState({
      ...state,
      selectedInventory: selectedInventory,
    });
  };

  const onAddInventory = () => {
    const { inventory_list, selectedInventory } = state;
    inventory_list.push(selectedInventory);
    setState({
      ...state,
      inventory_list,
      selectedInventory: null,
    });
  };

  const onChangeAdditionalAttribute = (attribute, item, attributeIndex) => {
    const newAttribute = { ...state?.additional_attributes };
    newAttribute[attribute][attributeIndex].is_required =
      !newAttribute[attribute][attributeIndex].is_required;
    setState({
      ...state,
      additional_attributes: newAttribute,
    });
  };

  const onRemoveAdditionalAttribute = (attribute) => {
    const { additional_attributes } = state;
    delete additional_attributes[attribute];
    setState({ ...state, additional_attributes: additional_attributes });
  };

  //show inventory function
  const onChangeInventoryAttribute = (parentIndex, attributeIndex, event) => {
    let inventoryList = state?.inventory_list;
    inventoryList[parentIndex]['inventory_attributes'][attributeIndex]['value'] =
      !!event.target.checked;
    setState({ ...state, inventory_list: inventoryList });
  };

  const onRemoveInventory = (index) => {
    const newInventoryList = state.inventory_list;
    newInventoryList.splice(index, 1);
    setState({ ...state, inventory_list: newInventoryList });
  };

  const onSearchBaseSupplierType = (e) => {
    getBaseSupplierTypeList({ search: e });
  };
  const backButton = () => {
    return <BackButton onClick={() => navigation(-1)} />;
  };

  useEffect(() => {
    const { isEditMode, supplierTypeId } = state;
    getBaseSupplierTypeList({ search: '' });
    getInventoryList();

    if (isEditMode) {
      getSupplierType(supplierTypeId);
    }
  }, []);

  useEffect(() => {
    if (state?.isEditMode && baseSupplierTypeList.length > 0) {
      let obj = baseSupplierTypeList?.find((item) => item?.id === state?.base_supplier_type_id);
      setState({ ...state, selectedBaseSupplierType: obj, base_supplier_type_id: obj?.id });
    }
  }, [baseSupplierTypeList]);

  return (
    <Box sx={{ backgroundColor: '#f8f9fa', borderRadius: '8px', p: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item>
          <Typography variant="h4" fontWeight="bold" sx={{ mb: 1 }}>
            {`Supplier Type - ${state.isEditMode ? 'Edit' : 'Create'}`}
          </Typography>
        </Grid>
        <Grid item>
          <BackButton onClick={() => navigation(`/r/supplier/type/list`)} />
        </Grid>
      </Grid>
      <form onSubmit={onSubmitSupplierType}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="normal">
              <TextField
                label={
                  <Typography>
                    Enter Name For Supplier Type <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                slotProps={{
                  inputLabel: {
                    sx: { top: '-7px' },
                  },
                }}
                name="name"
                value={state?.name || ''}
                onChange={handleInputChange}
                placeholder="Enter Name For Supplier Type"
                InputProps={{
                  sx: {
                    '& input': {
                      padding: '8px',
                    },
                  },
                }}
              />
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6}>
            <FormControl fullWidth margin="normal" sx={{ mt: 2 }}>
              <SearchableDropdown
                options={baseSupplierTypeList}
                labelKey="name"
                valueKey="id"
                label={
                  <Typography>
                    Select Base Supplier Type <span style={{ color: 'red' }}>*</span>
                  </Typography>
                }
                value={
                  isObjectBlank(state.selectedBaseSupplierType)
                    ? null
                    : state.selectedBaseSupplierType
                }
                onChange={onSelectBaseSupplierType}
                onSearch={onSearchBaseSupplierType}
                loading={false}
                error={false}
                errorMessage="Base Supplier Type is required"
                getOptionLabel={(option) => option.name}
              />
            </FormControl>
          </Grid>
        </Grid>
        <Box mt={2}>
          <FormLabel sx={{ mb: 1 }}>Additional Attributes</FormLabel>
          {Object.entries(state?.additional_attributes || {}).map(([header, fields]) => (
            <Box key={header} mb={2}>
              <Box display="flex" alignItems="center">
                <Typography variant="subtitle1">{getValueOfAttr(header)}</Typography>
                <IconButton onClick={() => onRemoveAdditionalAttribute(header)} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
              <FormGroup sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                {fields?.map((field, index) => (
                  <FormControlLabel
                    key={field.name}
                    control={
                      <Checkbox
                        checked={field?.value || field?.is_required}
                        onChange={() => onChangeAdditionalAttribute(header, field, index)}
                      />
                    }
                    label={field?.name}
                  />
                ))}
              </FormGroup>
            </Box>
          ))}

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <SearchableDropdown
                  options={additionalAttributesList}
                  labelKey="label"
                  valueKey="value"
                  label="Select Type"
                  value={state?.selectedAdditionalAttribute}
                  onChange={onAdditionalAttributeChange}
                  loading={false}
                  sx={{}}
                  multiSelect={false}
                  error={false}
                  errorMessage="Please select an attribute"
                  disabled={false}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                onClick={onAddAdditionalAttributes}
                disabled={!state.selectedAdditionalAttribute}
              >
                Add Additional Attribute
              </Button>
            </Grid>
          </Grid>
        </Box>
        <Box mt={2}>
          <FormLabel sx={{ mb: 1 }}>Inventory</FormLabel>
          <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: 2, overflowX: 'auto', mb: 2, // Scrollbar styles
          '&::-webkit-scrollbar': {
            height: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            backgroundColor: '#6f81ff', 
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#4158f5',
          },
          '&::-webkit-scrollbar-track': {
            backgroundColor: '#f1f1f1', 
          }, }}>
          {state?.inventory_list?.map((header, index) => (
            <Box sx={{ border: '1px solid #ccc', p: 2, borderRadius: '8px', mb: 2 , width:'max-content'}} key={index}>
            <Box key={`${header._id}${index}`} mb={0}>
              <Box display="flex" alignItems="center">
                <Typography variant="subtitle1">{header?.name}</Typography>
                <IconButton onClick={() => onRemoveInventory(index)} size="small">
                  <CloseIcon />
                </IconButton>
              </Box>
              <FormGroup>
                {header?.inventory_attributes?.map((field, attrIndex) => (
                  <FormControlLabel
                    key={field.name}
                    control={
                      <Checkbox
                        checked={field?.value || field?.is_required}
                        onChange={(e) => onChangeInventoryAttribute(index, attrIndex, e)}
                        disabled={field?.is_required}
                      />
                    }
                    label={field?.name}
                  />
                ))}
              </FormGroup>
            </Box>
            </Box>
          ))}
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <FormControl fullWidth>
                <SearchableDropdown
                  options={inventoryDataList}
                  labelKey="name"
                  valueKey="_id"
                  label="Select Inventory"
                  value={state.selectedInventory}
                  onChange={onInventoryChange}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Button
                variant="contained"
                onClick={onAddInventory}
                disabled={!state.selectedInventory}
              >
                Add Inventory
              </Button>
            </Grid>
          </Grid>
        </Box>

        {/* Submit Button */}
        <Box mt={3} sx={{ textAlign: { xs: 'center', sm: 'auto' } }}>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={
              state?.name?.trim().length <= 0 || isObjectBlank(state?.selectedBaseSupplierType)
            }
          >
            Submit
          </Button>
        </Box>
      </form>
    </Box>
  );
}
